import React, { useState, useEffect } from "react";

export default function ImageListViewInstagram({ images }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageData, setImageData] = useState([]);
  const [showTags, setShowTags] = useState(false);

  useEffect(() => {
    const data = images.map((img) => ({
      ...img,
      likes: Math.floor(Math.random() * (200 - 160 + 1)) + 160,
      comments: Math.floor(Math.random() * (15 - 6 + 1)) + 6,
    }));
    setImageData(data);
  }, [images]);

  const openModal = (img) => {
    setSelectedImage(img);
    setShowTags(false);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setShowTags(false);
  };

  const handleTagClick = (tag) => {
    if (tag.url) {
      window.location.href = tag.url;
    }
  };

  return (
    <>
      <div className="image-list-view-instagram">
        {imageData.map((img, index) => (
          <div
            key={index}
            className="list-item-instagram"
            onClick={() => openModal(img)}
          >
            <img src={img.src} alt={`post-${index}`} />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            {/* CLOSE */}
            <button className="close-btn" onClick={closeModal}>
              ✕
            </button>

            {/* IMAGE */}
            <img
              src={selectedImage.src}
              alt="selected"
              className="modal-img"
              onClick={() => setShowTags((prev) => !prev)}
            />

            {/* DESCRIPTION */}
            <p className="modal-description">{selectedImage.description}</p>

            {/* TAGS */}
            {showTags && selectedImage.tags && selectedImage.tags.length > 0 && (
              <div className="modal-tags">
                {selectedImage.tags.map((tag, index) => (
                  <button
                    key={index}
                    className="tag-pill"
                    onClick={() => handleTagClick(tag)}
                  >
                    {tag.name}
                  </button>
                ))}
              </div>
            )}

            {/* LIKES + COMMENTS */}
            <div className="modal-text">
              <span>{selectedImage.likes} likes</span>
              <span>{selectedImage.comments} comments</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
